export default __webpack_public_path__ + "static/media/warning--triple-curve-left--g1.2b1378be.png";